import clsx from 'clsx';
import { useCallback } from 'react';

export type Message = {
  role: 'ai' | 'user';
  content: string;
};

export const Message = ({
  message,
  index,
  messages,
}: {
  message: Message;
  index: number;
  messages: Message[];
  sessionId: string;
}) => {
  const isAssistant = useCallback(
    (message: Message) => message.role === 'ai',
    [],
  );

  return (
    <div
      className={clsx(
        'flex',
        isAssistant(message) ? 'justify-start' : 'justify-end',
        !isAssistant(message) ? 'user-message' : 'assistant-message',
      )}
    >
      {!isAssistant(message) && (
        <div className="ml-24 rounded-s-3xl rounded-br-3xl bg-[#F1F3F4] px-4 py-3">
          <p className="leading-6 tracking-tight text-[#1A1817]">
            {message.content}
          </p>
        </div>
      )}
      {isAssistant(message) && (
        <div className="flex gap-2.5">
          {index === 0 || messages[index - 1].role !== 'ai' ? (
            <img
              className="size-6"
              src="/logos/Hupo_Icon_Orange.svg"
              alt="Hupo icon"
            />
          ) : (
            <div className="size-6" />
          )}
          <div className="mr-24 rounded-e-3xl rounded-bl-3xl border border-gray-200 px-4 py-3">
            <p className="leading-6 tracking-tight text-[#1A1817]">
              {message.content}
            </p>
          </div>
        </div>
      )}
    </div>
  );
};
